import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';
import { dateFormat } from '../../../lib/utils';

const { RangePicker } = DatePicker;

const DateRangeSelector = ({
  startDate,
  endDate,
  className = 'w-64',
}: {
  startDate?: string | null | undefined;
  endDate?: string | null | undefined;
  className?: string | undefined;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <RangePicker
      onChange={(dates, dateStrings) => {
        setSearchParams((prev) => {
          prev.set('start', dateStrings[0]);
          return prev;
        });
        setSearchParams((prev) => {
          prev.set('end', dateStrings[1]);
          return prev;
        });
      }}
      className={className}
      allowClear={false}
      format={dateFormat}
      defaultValue={[dayjs(startDate), dayjs(endDate)]}
      placeholder={['Start date', 'End date']}
    />
  );
};

export default DateRangeSelector;
